import { render } from "./ModalEditSuppliersGroup.vue?vue&type=template&id=0e36f342&scoped=true"
import script from "./ModalEditSuppliersGroup.vue?vue&type=script&lang=js"
export * from "./ModalEditSuppliersGroup.vue?vue&type=script&lang=js"

import "./ModalEditSuppliersGroup.vue?vue&type=style&index=0&id=0e36f342&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e36f342"]])

export default __exports__